import React, { useMemo } from 'react';
import { StyleSheet, Platform } from 'react-native';
import Button from '@/components/Buttons/Button';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';

const createStyles = (colors, visible) => StyleSheet.create({
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: `${colors.solid_color_secondary}dd`,
    backdropFilter: 'blur(8px)',
    WebkitBackdropFilter: 'blur(8px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
    opacity: visible ? 1 : 0,
    pointerEvents: visible ? 'auto' : 'none',
    transition: 'opacity 0.2s ease-in-out',
  },
  content: {
    padding: 40,
    borderRadius: 16,
    borderWidth: 3,
    borderStyle: 'dashed',
    borderColor: colors.text_color_secondary,
    backgroundColor: colors.solid_color_block,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 12,
    position: 'relative',
  },
  closeButton: {
    position: 'absolute',
    top: 8,
    right: 8,
    padding: 8,
    borderRadius: 20,
    backgroundColor: colors.solid_color_secondary,
  },
  icon: {
    color: colors.text_color_secondary,
  }
});

function DragDropOverlay({ colors, visible, onDrop, description = 'Release to upload files to the chat' }) {
  const styles = useMemo(() => createStyles(colors, visible), [colors, visible]);

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const files = Array.from(e.dataTransfer.files);
    onDrop(files);
  };

  if (Platform.OS !== 'web' || !visible) return null;

  return (
    <div 
      style={styles.overlay}
      onDragOver={handleDragOver}
      onDragEnter={handleDragEnter}
      onDrop={handleDrop}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onDrop([]); // Close overlay when clicking outside
      }}
    >
      <div 
        style={styles.content}
        onClick={(e) => e.stopPropagation()} // Prevent content clicks from closing
      >
        <Button
          icon="xmark"
          size="small"
          variant="secondary"
          style={styles.closeButton}
          onPress={() => onDrop([])} // Close overlay
        />
        <Icon name="files" size={24} fal style={styles.icon} />
        <Text size="l" weight="bold" color="primary">Drop files here</Text>
        <Text size="n" color="secondary">{description}</Text>
      </div>
    </div>
  );
}

export default DragDropOverlay; 